import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateFinalDomain = ({
  Show,
  Hide,
  Title,
  studyId,
  getCDISCStudyFinalDomain,
  domainData,
}) => {
  const [targetDomainName, setTargetDomainName] = useState("");
  const [targetDomainLabel, setTargetDomainLabel] = useState("");
  const [targetDomainClass, setTargetDomainClass] = useState("");
  const [targetDomainType, setTargetDomainType] = useState("");
  const [key, setKey] = useState([]);

  const [buttonLoader, setButtonLoader] = useState(false);

  /* -------------------- LOAD DATA -------------------- */
  useEffect(() => {
    if (domainData) {
      setTargetDomainName(domainData.targetDomainName || "");
      setTargetDomainLabel(domainData.targetDomainLabel || "");
      setTargetDomainClass(domainData.targetDomainClass || "");
      setTargetDomainType(domainData.targetDomainType || "");
      setKey(domainData.key || []);
    }
  }, [domainData]);

  /* -------------------- UPDATE -------------------- */
  const updateCDISCStudyFinalDomain = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this domain?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonColor: "#d33",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);

        const userData = {};
        userData.id = domainData?._id;
        userData.domainId = domainData?.domainId;
        userData.studyId = studyId;
        userData.targetDomainName = targetDomainName;
        userData.targetDomainLabel = targetDomainLabel;
        userData.targetDomainClass = targetDomainClass;
        userData.targetDomainType = targetDomainType;
        userData.key = key;

        let data = await cdiscManagementService.updateCDISCStudyFinalDomain(userData);

        if (data?.statusCode === 200) {
          getCDISCStudyFinalDomain();
          Hide();
        }

        setButtonLoader(false);
      }
    });
  };

  /* -------------------- UI -------------------- */
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Target Domain Name</Form.Label>
          <Form.Control
            value={targetDomainName}
            onChange={(e) => setTargetDomainName(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Target Domain Label</Form.Label>
          <Form.Control
            value={targetDomainLabel}
            onChange={(e) => setTargetDomainLabel(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Target Domain Class</Form.Label>
          <Form.Control
            value={targetDomainClass}
            onChange={(e) => setTargetDomainClass(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Target Domain Type</Form.Label>
          <Form.Control
            value={targetDomainType}
            onChange={(e) => setTargetDomainType(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label className="fw-bold">Key (comma separated)</Form.Label>
          <Form.Control
            value={key.join(", ")}
            onChange={(e) =>
              setKey(
                e.target.value
                  .split(",")
                  .map(k => k.trim())
                  .filter(Boolean)
              )
            }
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top hstack justify-content-end">
        <button
          className="updateProfile"
          disabled={buttonLoader}
          onClick={updateCDISCStudyFinalDomain}
        >
          {buttonLoader ? (
            <>
              <Spinner size="sm" /> Updating...
            </>
          ) : (
            "Update Domain"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateFinalDomain;
